<template>
  <div :id="chartId" style="height: 300px; width: 100%;" />
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import * as echarts from 'echarts';

import { Nullable } from '@/utils/types';
import { IVisualizationDataItem } from '@/bundles/Visualizations/interfaces/IVisualizationDataItem';

interface IEChartPie {
  myChart: Nullable<echarts.ECharts>;
}

export default Vue.extend({
  name: 'EChartPie',

  props: {
    chartId: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    chartData: {
      type: Array as PropType<IVisualizationDataItem[]>,
      required: true
    },
    series: {
      type: Object as PropType<echarts.PieSeriesOption>,
      default: () => ({}),
    }
  },

  data: (): IEChartPie => ({
    myChart: null,
  }),

  watch: {
    chartData: {
      handler () {
        this.loadChart();
      },
      deep: true,
    }
  },

  mounted () { // can't be moved to watch because it will be called before mounted
    this.loadChart();
  },

  methods: {
    loadChart () {
      const container = document.getElementById(this.chartId);

      if (!container) {
        return;
      }

      if (!this.myChart) {
        this.myChart = echarts.init(container);
      }

      this.myChart.setOption({
          tooltip: {
            trigger: 'item'
          },
          legend: {
            top: 0,
            type: 'scroll',
            orient: 'vertical',
            left: 0,
            itemWidth: 20,
            itemHeight: 20,
            textStyle: {
              width: Math.round(this.myChart.getWidth() / 2) - 50, // 50 is the padding around pie
              overflow: 'break',
            }
          },
          series: [
            {
              name: this.label,
              type: 'pie',
              radius: ['40%', '70%'],
              padAngle: 0,
              itemStyle: {
                borderRadius: 0
              },
              data: this.chartData,
              emphasis: {
                label: {
                  show: true,
                  fontSize: 20,
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                show: false
              },
              label: {
                show: false,
                position: 'center'
              },
              center: ['70%', '50%'], // align to right
              color: [
                '#2563EB', // Primary Blue
                '#0D9488', // Teal
                '#EA580C', // Orange
                '#7C3AED', // Purple
                '#E11D48', // Rose
                '#0891B2', // Cyan
                '#D97706', // Amber
                '#4F46E5', // Indigo
                '#059669', // Emerald
                '#DB2777', // Pink
                '#475569', // Slate
                '#65A30D', // Lime
                '#0284C7', // Sky
                '#C026D3', // Fuchsia
                '#CA8A04', // Yellow
                '#DC2626', // Red
              ],
              ...this.series,
            }
          ]
        },
        true
      );
    }
  }
})
</script>
